/**
 * @author Simon
 * @description web ble
 * @version 1.0
 */
// const Utils = require('./utils');
// const FakeWebsocket = require('./fake-websocket');
// const Base64Util = require('./base64-util');
import Utils from './utils.js';
import FakeWebsocket from './fake-websocket.js';
import Base64Util from './base64-util.js';
import store from '../store'
import { setConnectState, setDeviceList } from '../store/connect-state.js'
import { setVariableList } from '../store/api-state.js'

const BLE_INFO = {
    service: '6e400001-b5a3-f393-e0a9-e50e20191008',
    rxChar: '6e400003-b5a3-f393-e0a9-e50e20191008',
    txChar: '6e400002-b5a3-f393-e0a9-e50e20191008',
    name: 'VinciBot',
    namePrefix: 'VinciBot'
};

class ScratchLinkBle {
    constructor(type) {
        this._type = type;
        this._onOpen = null;
        this._onClose = null;
        this._onError = null;
        this._handleMessage = null;
        this._onConnect = null;

        this._ws = null;
        this._device = null;
        this._service = null;
        this._rxChar = null;
        this._txChar = null;
        this._readyToClose = false;
        this._keepReading = false;
    }

    open() {
        if (!(this._onOpen && this._onClose && this._onError && this._handleMessage)) {
            throw new Error('Must set open, close, message and error handlers before calling open on the socket');
        }

        this._ws = new FakeWebsocket();
        this._ws.onopen = this._onOpen;
        this._ws.onclose = this._onClose;
        this._ws.onerror = this._onError;
        this._ws.onmessage = this._onMessage.bind(this);

        this._onOpen();
        // eslint-disable-next-line no-negated-condition
        if (navigator.bluetooth) {
            const options = {
                filters: [
                    { services: ['6e400001-b5a3-f393-e0a9-e50e20191008'] },
                    { name: 'Nous' },
                    { namePrefix: 'Nous' }
                ]
            };
            navigator.bluetooth.requestDevice(options)
                .then(device => {
                    this._device = device;
                    this._device.addEventListener('gattserverdisconnected', this._onClose);
                    return this._device.gatt.connect();
                })
                .then(server => {
                    // 调用自定义的处理连接成功的函数
                    this.handleBluetoothConnect(server);
                })
                .catch(error => {
                    // console.info(error);
                    this._onError(error);
                });
        } else {
            this._onError('not support');
        }
    }

    async handleBluetoothConnect(server) {
        // 在连接成功后，处理数据传输和与蓝牙设备的通信逻辑
        // 可以在这里进行数据读写等操作
        // 例如获取服务和特征，读取特征的值，写入特征等
        // console.log(`已连接到蓝牙设备: ${this._device.id}`);
        try {
            // 获取主要服务
            const service = await server.getPrimaryService(BLE_INFO.service);
            // 获取特征
            this._rxChar = await service.getCharacteristic(BLE_INFO.rxChar);
            this._txChar = await service.getCharacteristic(BLE_INFO.txChar);
            // 订阅特征的通知，以便实时接收数据
            // await this._rxChar.startNotifications();
            // this._rxChar.addEventListener('characteristicvaluechanged', this._onRxCharValueChanged.bind(this));
        } catch (error) {
            // console.info(error);
            this._onError(error);
        }
        this._onConnect(this._device.id);
    }

    // 添加特征值变化监听的回调函数
    _onRxCharValueChanged(event) {
        const value = event.target.value;
        const data = new Uint8Array(value.buffer);
        const base64Data = Base64Util.uint8ArrayToBase64(data);
        // eslint-disable-next-line max-len
        this._onMessage(`{"jsonrpc":"2.0","method":"characteristicDidChange","params":{"message":"${base64Data}","encoding":"base64"}}`);
    }

    async _getDevices() {
        const options = {
            filters: [
                { services: [BLE_INFO.service] },
                { name: BLE_INFO.name },
                { namePrefix: BLE_INFO.namePrefix }
            ]
        };

        try {
            return await navigator.bluetooth.requestDevice(options);
        } catch (error) {
            // console.info(error);
            throw error;
        }
    }

    getInfo() {
        // eslint-disable-next-line eqeqeq
        if (this._device !== null) {
            // eslint-disable-next-line max-len
            console.log(`WebSerial VendorID 0x${this._device.id.toString(16)} ProductID 0x${this._device.name.toString(16)}`);
            return this._device.id;
        }
        return null;
    }

    // async write (data) {
    //     try {
    //         const service = await this._device.gatt.getPrimaryService(BLE_INFO.service);
    //         const characteristic = await service.getCharacteristic(BLE_INFO.txChar);
    //         await characteristic.writeValue(data);
    //     } catch (error) {
    //         console.info(error);
    //         throw error;
    //     }
    // }
    async write(data) {
        try {
            await this._txChar.writeValue(data);
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    // portWrite (value) {
    //     return new Promise(async (resolve, reject) => {
    //         if (this._device === null) {
    //             reject();
    //             return;
    //         }
    //         try {
    //             const service = await this._device.gatt.getPrimaryService(BLE_INFO.service);
    //             const characteristic = await service.getCharacteristic(BLE_INFO.txChar);
    //             await characteristic.writeValue(value.buffer);
    //         } catch (error) {
    //             console.info(error);
    //             throw error;
    //         }
    //         resolve(value);
    //     });
    // }
    async portWrite(value) {
        if (this._device === null) {
            throw new Error('Device is not connected');
        }

        try {
            await this._txChar.writeValue(value.buffer);
            return value;
        } catch (error) {
            console.info(error);
            throw error;
        }
    }

    async readText() {
        if (!this._device || !this._device.gatt.connected) {
            console.log('device not connected');
            return;
        }

        // Check if characteristic supports notifications
        if (!this._rxChar.properties.notify) {
            console.info('Characteristic does not support notifications.');
            return;
        }
        try {
            // 启动特征值的通知
            await this._rxChar.startNotifications();
            // 添加特征值变化的事件监听
            this._rxChar.addEventListener('characteristicvaluechanged', this._onRxCharValueChanged.bind(this));
        } catch (error) {
            console.info('启动通知时发生错误：', error);
            this._onError(error);
        }
    }

    closeSerial() {
        return new Promise(async(resolve, reject) => {
            if (this._device) {
                this._keepReading = false;
                try {
                    if (this._device.gatt.connected && this._rxChar && this._rxChar.properties.notify) {
                        // 停止特征值的通知监听
                        await this._rxChar.stopNotifications();
                        this._rxChar.removeEventListener('characteristicvaluechanged', this._onRxCharValueChanged);
                    }
                    await this._device.gatt.disconnect();
                } catch (e) {
                    console.info('关闭设备连接时发生错误：', e);
                }
                this._device = null;
                this._txChar = null;
                this._rxChar = null;
                this._onClose();
                this._readyToClose = true;
                resolve();
            } else {
                reject();
            }
        });
    }

    close() {
        this._ws = null;
        this.closeSerial();
    }

    sendMessage(message) {
        // const messageText = JSON.stringify(message);
        this.parseMessage(message);
    }

    setOnOpen(fn) {
        this._onOpen = fn;
    }

    setOnClose(fn) {
        this._onClose = fn;
    }

    setOnError(fn) {
        this._onError = fn;
    }

    setHandleMessage(fn) {
        this._handleMessage = fn;
    }

    setOnConnect(fn) {
        this._onConnect = fn;
    }

    isOpen() {
        return this._ws;
    }

    _onMessage(e) {
        // console.log(e);
        const json = JSON.parse(e);
        this._handleMessage(json);
    }

    parseMessage(messageText) {
        // console.log(messageText);
        const { method, params, id } = messageText;
        // console.log(method);
        // console.log(params);
        let data;
        switch (method) {
            case 'discover':
            case 'connect':
                this._onMessage(`{"id":${id},"jsonrpc":"2.0","result":null}`);
                break;
            case 'disconnect':
                store.dispatch(setConnectState(false));
                // // 变量展示清空
                const Variabledata = {
                    distance: 0,
                    volume: 0,
                    tempoValue: 0,
                    soundIntensity: 0
                }
                store.dispatch(setVariableList(Variabledata));
                // 设备数据清空
                store.dispatch(setDeviceList([]));
                // this.closeSerial()
                //     .then(r => console.log('close'));
                // this._onClose();
                break;
            case 'startNotifications':
                this._onMessage(`{"id":${id},"jsonrpc":"2.0","result":null}`);
                this._keepReading = true;
                this.readText()
                    .then(r => console.log('start notifications'));
                break;
            case 'write':
                data = Base64Util.base64ToUint8Array(params.message);
                this.portWrite(data)
                    .then(res => {
                        this._onMessage(`{"id":${id},"jsonrpc":"2.0","result":${data.length}}`);
                    });
                break;
            default:
                break;
        }
    }
}

// module.exports = ScratchLinkBle;
export default ScratchLinkBle;